import type { Locale } from 'date-fns'
import { enUS, zhCN } from 'date-fns/locale'

import type { Language } from '@/lib/i18n/translations'

const DATE_FNS_LOCALES: Record<Language, Locale> = {
  en: enUS,
  zh: zhCN,
}

export function getDateFnsLocale(language: Language): Locale {
  return DATE_FNS_LOCALES[language] ?? enUS
}
